import script from "./CabecalhoPrincipal.vue?vue&type=script&setup=true&lang=js"
export * from "./CabecalhoPrincipal.vue?vue&type=script&setup=true&lang=js"

import "./CabecalhoPrincipal.vue?vue&type=style&index=0&id=094c05c0&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-094c05c0"]])

export default __exports__